import React from 'react';
import { Box, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useSelector } from 'react-redux';
import { handleValidateCodevalue } from '../../Utility/constant';
import './unauthorized.css';

const UnauthorizedPage = () => {
    const internationalise = useSelector((state) => state?.internationalise?.currentHashMapData);

    return (
        <Box className="unauthorized-page-container">
            <Box className="unauthorized-card-box">
                <Box className="unauthorized-icon-circle">
                    <LockOutlinedIcon className="unauthorized-lock-icon" />
                </Box>

                <Typography variant="h5" fontWeight={600} color="text.primary" gutterBottom>
                    {handleValidateCodevalue(internationalise, "COMMON_UNAUTHORIZED_ACCESS")}
                </Typography>

                <Typography variant="body2" color="text.secondary" className="unauthorized-description-text">
                    {handleValidateCodevalue(internationalise, "COMMON_UNAUTHORIZED_DESC") ||
                     "You do not have permission to view this section. Please contact your administrator for assistance."}
                </Typography>
            </Box>
        </Box>
    );
};

export default UnauthorizedPage;
